"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Add possibility to detach lightbox in handheld view
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.images.lightbox = {
    anchors: {},
    setAnchors: function () {
        _main_1.txGs1Base.images.lightbox.anchors = $('a[rel=imagebox]');
    },
    detach: function () {
        'use strict';
        _main_1.txGs1Base.images.lightbox.anchors.off('click').on('click.txGs1Base', function (event) {
            event.preventDefault();
        });
    },
    attach: function () {
        'use strict';
        _main_1.txGs1Base.images.lightbox.anchors.off('click.txGs1Base').fancybox({
            parent: '#main',
            live: false,
            margin: 0,
            padding: 50,
            openMethod: 'modalIn',
            tpl: {
                wrap: '<div class="fancybox-wrap" id="fancybox" tabIndex="-1"><div class="fancybox-skin modal-dialog"><div class="fancybox-outer modal-content"><div class="fancybox-inner modal-body"></div></div></div></div>',
                closeBtn: '<button class="fancybox-item fancybox-close btn--close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>',
                prev: '<a title="" class="fancybox-nav fancybox-prev" href="javascript:;"><span class="icon-arrow_left" aria-hidden="true"></span></a>',
                next: '<a title="" class="fancybox-nav fancybox-next" href="javascript:;"><span class="icon-arrow_right" aria-hidden="true"></span></a>'
            },
            helpers: {
                title: {
                    type: 'inside',
                    position: 'bottom'
                },
                overlay: {
                    locked: false
                }
            },
            afterLoad: function () {
                if ($(this.element).data('caption').length > 0) {
                    // Use caption from data-attribute
                    this.title = $(this.element).data('caption');
                }
                else {
                    this.title = "";
                }
            },
            afterShow: function () {
                let $modalDialog = $('.modal-dialog');
                if (this.title !== "") {
                    $modalDialog.addClass('has-title');
                }
                $modalDialog.animate({
                    top: 0,
                    opacity: 1
                }, 500);
            }
        });
    }
};
exports.default = {};
